/* eslint-disable */
// @ts-nocheck
import { Search, X } from 'lucide-react'
import { useCallback, useEffect, useRef, useState } from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { useDebounce } from '@/hooks/useDebounce'

interface SearchQueryProps {
  searchQuery: string
  onSearchChange: (value: string) => void
  placeholder?: string
  onlyNumbers?: boolean
}

export const SearchQuery = ({
  searchQuery,
  onSearchChange,
  placeholder = 'Buscar por número de factura...',
  onlyNumbers = false,
}: SearchQueryProps) => {
  const [searchValue, setSearchValue] = useState(searchQuery)
  const debouncedSearchValue = useDebounce(searchValue, 600)
  const lastPropRef = useRef(searchQuery)

  // 🔹 Sincroniza el valor externo (nuqs) con el input, pero evita loops infinitos
  useEffect(() => {
    // Solo actualiza si el valor externo cambió realmente
    if (searchQuery !== lastPropRef.current) {
      lastPropRef.current = searchQuery
      setSearchValue(searchQuery || '') // asegura que el input se resetee a ""
    }
  }, [searchQuery])

  // 🔹 Ejecuta búsqueda con debounce solo si cambió realmente el valor
  useEffect(() => {
    if (debouncedSearchValue !== lastPropRef.current) {
      lastPropRef.current = debouncedSearchValue
      onSearchChange(debouncedSearchValue)
    }
  }, [debouncedSearchValue])

  const handleClear = useCallback(() => {
    setSearchValue('')
    onSearchChange('')
  }, [onSearchChange])

  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      let value = e.target.value
      if (onlyNumbers) value = value.replace(/[^0-9]/g, '')
      setSearchValue(value)
    },
    [onlyNumbers]
  )

  return (
    <div className="relative min-w-[240px] flex-1">
      <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
      <Input
        className="bg-white pl-9 pr-4"
        onChange={handleInputChange}
        placeholder={placeholder}
        value={searchValue}
      />
      {searchValue && (
        <Button
          className="absolute right-1 top-1.5 h-7 w-7"
          onClick={handleClear}
          size="icon"
          variant="ghost"
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  )
}
